module.exports = __webpack_public_path__ + "img/tl.a76d2378.svg";